
      const customCSSPropertiesMap = {
        "avatarSize": "--awsui-avatar-size-qkxefc",
"avatarRootBorderWidth": "--awsui-avatar-root-border-width-qkxefc",
"avatarFocusRingBorderColor": "--awsui-avatar-focus-ring-border-color-qkxefc",
"avatarFocusRingBorderRadius": "--awsui-avatar-focus-ring-border-radius-qkxefc",
"avatarFocusRingBorderWidth": "--awsui-avatar-focus-ring-border-width-qkxefc",
      };
      export default customCSSPropertiesMap;
    